export default __webpack_public_path__ + "static/media/todo.e7b8d18a.PNG";